module.exports = __webpack_public_path__ + "img/SharpnessEnhancement01.d4233957.png";